import clsx from "clsx";
import React, { PropsWithoutRef, ReactElement } from "react";
import { Icon } from "../Icon/Icon";
import styles from "./Tab.module.scss";

import { Tab as BaseTab, TabProps } from "react-tabs";
import { IconsId } from "@silversea-ssc/design-system-icons";

type Props = PropsWithoutRef<TabProps> & {
  underline?: boolean;
  info?: ReactElement;
  icon?: IconsId;
  variant?: "auto" | "wide";
  backgroundColor?: "white" | "neutral05" | "destinationExtralight";
  noWrap?: boolean;
};

export const Tab: React.FC<React.PropsWithChildren<Props>> & {
  tabsRole: string;
} = ({
  children,
  info,
  underline,
  icon,
  backgroundColor = "neutral05",
  variant = "auto",
  noWrap,
  ...props
}) => {
  return (
    <BaseTab
      {...props}
      disabledClassName={styles.tabDisabled}
      selectedClassName={styles.tabSelected}
      className={clsx(styles.tab, {
        [styles.noWrap]: noWrap,
        [styles.tabUnderline]: underline,
        [styles.tabSizeWide]: variant == "wide",
        [styles.tabBackgroundDestination]:
          backgroundColor == "destinationExtralight",
        [styles.tabBackgroundWhite]: backgroundColor == "white",
        [styles.tabBackgroundNeutral05]: backgroundColor == "neutral05"
      })}
    >
      <div className={styles.label}>
        {icon && (
          <Icon
            name={icon}
            size="1.5x"
            padding={false}
            className={styles.icon}
          />
        )}
        {children}
      </div>
      {info && <div className={styles.info}>{info}</div>}
    </BaseTab>
  );
};

Tab.tabsRole = "Tab";
